import { RootReducer } from 'rootReducer';

export const getAudioCommentRecording = (state: RootReducer) => state.audioRecorderReducer.recording;
